import store from '$$globalStore';
import plansModel from '../../../models/plans';

function onTeamSubscriptionUpdated(event) {
  const isUpdatedFromApp = store.getters['paymentClient/isUpdatedFromApp'];

  if (event.data.data.type === 'subscriptionTerminated') {
    document.location.reload();
  }

  if (event.data.data.type === 'subscriptionUpdated') {
    webix.message({ type: 'success', text: __('notifications_order_SubscriptionChargeSucceed') });

    if (!isUpdatedFromApp) {
      document.location.reload();
    }
  }

  if (event.data.data.type === 'orderCharged' && !isUpdatedFromApp && !plansModel.isTrial()) {
    document.location.reload();
  }

  if (GT.user.id !== GT.user.team.owner_id) {
    document.location.reload();
  }
}

export default onTeamSubscriptionUpdated;
